<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-loyalty-results">

    <page-title :title="'Program lojalnościowy'" :back="true"></page-title>

    <loyalty-segment :value="'LoyaltyResults'"></loyalty-segment>

    <card-loyalty-filter-results></card-loyalty-filter-results>

    <card-loyalty-contract v-if="currentContract"
                           title="Twoja umowa"
                           :active="currentContract.active"
                           :status="currentContract.status"
                           :place_name="currentPlace.name"
                           :brand="currentContract.brand"
                           :uuid="currentContract.contract_uuid"
                           :canConfirm="false"
                           :canRemove="false">
    </card-loyalty-contract>

    <ion-slides v-if="showLoyalty"
                ref="slides"
                @ionSlideDidChange="slideChanged"
                :options="slideOpts"
                mode="md">
      <ion-slide v-for="(item,index) in loyaltyResultsBox" :key="index">
        <item-loyalty-result
            :index="index"
            :title="item.month"
            :status="item.status"
            :volume="item.volume"
            :tables="item.tables">
        </item-loyalty-result>
      </ion-slide>
    </ion-slides>

  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';
  import PageTitle from '@/components/PageTitle.vue';
  import LoyaltySegment from '@/navs/LoyaltySegment';
  import CardLoyaltyContract from '@/cards/CardLoyaltyContract';
  import CardLoyaltyFilterResults from '@/cards/CardLoyaltyFilterResults';
  import ItemLoyaltyResult from '@/items/ItemLoyaltyResult';
  import {createHelpers} from "vuex-map-fields";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'LoyaltyResults',
    components: {
      PageTitle,
      LoyaltySegment,
      CardLoyaltyContract,
      CardLoyaltyFilterResults,
      ItemLoyaltyResult
    },
    computed: {
      ...mapGetters('profile', ['getProfile']),
      ...mapState({
        results: state => state.loyalty.results
      }),
      ...mapFields({
        sfa: 'filterResultsForm.sfa'
      }),
      currentPlace(){
        return this.getProfile.places.find(x => x.sfa === this.sfa)
      },
      currentContract(){
        return this.currentPlace ? this.currentPlace.loyalty_program : null
      },
      loyaltyResultsBox(){
        return this.results ? this.results.box : null
      },
      showLoyalty(){
        return this.loyaltyResultsBox ? true : false
      }
    },
    data() {
      return {
        // slider helpers
        sliderIndex: 0,
        sliderLength: 0,
        sliderEnd: false,
        // slider options
        slideOpts: {
          slidesPerView: 1,
        },
        // TODO results notifications?
      }
    },
    mounted() {

    },
    methods: {
      slideChanged(){
        // update slider helpers
        this.$refs.slides.getActiveIndex().then(index => {
          this.sliderIndex = index
        })
        this.$refs.slides.length().then(length => {
          this.sliderLength = length
        })
        this.$refs.slides.isEnd().then(bool => {
          this.sliderEnd = bool
        })
      },
      slideTo(index){
        if(!this.$refs.slides) return
        this.$refs.slides.slideTo(index);
      }
    }
  }
</script>